import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface DocumentosInvestigacionPayload {
  codigo: string;
  version: string;
  fecha_designacion: string; // formato YYYY-MM-DD
  fecha_vencimiento: string; // formato YYYY-MM-DD
  motivo_creacion: string;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface DocumentosInvestigacion {
  id?: number;
  codigo: string;
  version: string;
  fecha_designacion: string;
  fecha_vencimiento: string;
  motivo_creacion: string;
  estado: number;
  fechacreacion?: string;
  fechamodificacion?: string | null;
}

export interface DocumentosInvestigacionResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class DocumentosInvestigacionService {
  private readonly apiUrl = `${environment.apiUrl}/api/documentos_investigacion`;

  constructor(private http: HttpClient) {}

  // Listar todos los documentos de investigación
  getAll(): Observable<DocumentosInvestigacion[]> {
    return this.http.get<DocumentosInvestigacion[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<DocumentosInvestigacion> {
    return this.http.get<DocumentosInvestigacion>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nuevo documento de investigación
  create(payload: DocumentosInvestigacionPayload): Observable<DocumentosInvestigacionResponse> {
    return this.http.post<DocumentosInvestigacionResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar documento de investigación
  update(id: number, payload: Partial<DocumentosInvestigacionPayload>): Observable<DocumentosInvestigacionResponse> {
    return this.http.put<DocumentosInvestigacionResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar documento de investigación (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar documento de investigación
  inactivar(id: number): Observable<DocumentosInvestigacionResponse> {
    return this.http.put<DocumentosInvestigacionResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar documento de investigación
  activar(id: number): Observable<DocumentosInvestigacionResponse> {
    return this.http.put<DocumentosInvestigacionResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}